<template>
  <div class="user">
    <ul v-for="item in userData" :key="item.index">
      <li><span>昵称</span>：{{ item.nickName }}</li>
      <li><span>账号</span>：{{ item.phone }}</li>
      <li><span>专业</span>：{{ item.channel }}</li>
      <li><span>地址</span>：{{ item.address }}</li>
      <li><span>发票名称</span>：{{ item.ticketName }}</li>
      <li><span>纳税人识别号</span>：{{ item.ticketCode }}</li>
      <li><span>地址、电话</span>：{{ item.ticketName }}</li>
      <li><span>开户行及账号</span>：{{ item.ticketBank }}</li>
    </ul>
    <el-button :icon="Edit" type="primary" @click="editUserInfo"
      >点击修改</el-button
    >
  </div>
  <div class="dialog">
    <el-dialog v-model="editFormVisible" title="个人信息修改" width="500">
      <el-form :model="form">
        <el-form-item label="昵称：">
          <el-input v-model="form.nickName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="手机号码：">
          <el-input v-model="form.phone" autocomplete="off" disabled />
        </el-form-item>
        <el-form-item label="头像：">
          <el-upload
            class="avatar-uploader"
            action="/web/user/image"
            :on-preview="userImagePreview"
            :on-remove="userImageRemove"
            list-type="picture"
            :on-success="userImageUpload"
          >
            <div>
              <img
                v-show="userImage"
                style="width: 650px; height: 100%"
                :src="form.image"
              />
            </div>
            <el-button size="default" type="primary"
              >点击上传/修改头像</el-button
            >
          </el-upload>
          <!--  <el-form-item style="margin-top: 35px" label="头像">
            <el-input style="width: 550px" v-model="form.image"></el-input>
          </el-form-item> -->
        </el-form-item>
        <el-form-item label="地址：">
          <el-input v-model="form.address" autocomplete="off" />
        </el-form-item>
        <el-form-item label="发票名称：">
          <el-input v-model="form.ticketName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="纳税识别号：">
          <el-input v-model="form.ticketCode" autocomplete="off" />
        </el-form-item>
        <el-form-item label="地址、电话：">
          <el-input v-model="form.ticketAddress" autocomplete="off" />
        </el-form-item>
        <el-form-item label="开户行及账号：">
          <el-input v-model="form.ticketBank" autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click="putEditUserInfo">
            确定修改
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Edit } from "@element-plus/icons-vue";
import { ref } from "vue";
import { getInfoUpdate, updateUserInfo } from "@/api/user";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
export default {
  props: {
    userData: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const store = useStore();
    const editFormVisible = ref(false);
    const userImage = ref(false);
    const form = ref({
      nickName: "",
      phone: "",
      image: "",
      address: "",
      ticketName: "",
      ticketCode: "",
      ticketAddress: "",
      ticketBank: "",
    });
    const editUserInfo = () => {
      editFormVisible.value = true;
      getInfoUpdate({ id: store.state.user.profile._id }).then((data) => {
        try {
          form.value.nickName = data[0].nickName;
          form.value.phone = data[0].phone;
          form.value.image = data[0].image;
          form.value.address = data[0].address;
          form.value.ticketName = data[0].ticketName;
          form.value.ticketCode = data[0].ticketCode;
          form.value.ticketAddress = data[0].ticketAddress;
          form.value.ticketBank = data[0].ticketBank;
        } catch (error) {
          console.log(error);
        }
      });
    };

    const putEditUserInfo = () => {
      try {
        updateUserInfo({
          userID: store.state.user.profile._id,
          nickName: form.value.nickName,
          image: form.value.image,
          address: form.value.address,
          ticketName: form.value.ticketName,
          ticketCode: form.value.ticketCode,
          ticketAddress: form.value.ticketAddress,
          ticketBank: form.value.ticketBank,
        }).then((data) => {
          if (data.code == 201) {
            ElMessage({
              message: data.msg,
              type: "success",
            });
          }
        });
      } catch (error) {
        ElMessage.error(error.message);
      }
      editFormVisible.value = false;
    };

    const userImageUpload = (res) => {
      try {
        form.value.image = res;
      } catch (error) {
        console.log(error);
      }
      //console.log(res);
    };

    const userImageRemove = (res) => {
      try {
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    };
    const userImagePreview = (file) => {
      try {
        console.log(file);
      } catch (error) {
        console.log(error);
      }
    };

    return {
      Edit,
      editFormVisible,
      form,
      editUserInfo,
      userImageUpload,
      userImageRemove,
      userImagePreview,
      userImage,
      putEditUserInfo,
    };
  },
};
</script>

<style lang="less" scoped>
.user {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  ul {
    li {
      height: 35px;
      span {
        display: inline-block;
        font-weight: bold;
        width: 110px;
        text-align-last: justify;
      }
    }
  }
}
</style>
